import { taskApiURl } from "API/urls/task.api";
import { axiosInstance } from "configs/axios";

export const fetchTasksApi = async (payload) => {
  try {
    const response = await axiosInstance.post(taskApiURl.getList, {
      ...payload,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
